import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Paper,
} from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { register, login } from '../../models/Account';
import { useNavigate } from 'react-router-dom';

export default function AuthFormSection() {
  const [registerForm, setRegisterForm] = useState({ username: '', email: '', password: '' });
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [registerError, setRegisterError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await login(loginForm);
      const [data, status] = res;

      if (status === 200 || status === 201) {
        localStorage.setItem('token', data.token);
        navigate('/');
      } else {
        const errorMessage = typeof data === 'string' ? data : 'Đăng nhập thất bại. Vui lòng thử lại.';
        setLoginError(errorMessage);
      }
    } catch (err) {
      setLoginError('Lỗi máy chủ. Vui lòng thử lại sau.');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setRegisterError('');

    if (registerForm.password !== registerForm.rePassword) {
      setRegisterError('Mật khẩu không khớp.');
      return;
    }

    try {
      const res = await register(registerForm);
      const [data, status] = res;

      if ((status === 200 || status === 201) && data?.token) {
        localStorage.setItem('token', data.token);
        navigate('/');
      } else {
        const errorMessage = typeof data === 'string' ? data : 'Đăng ký thất bại. Vui lòng thử lại.';
        setRegisterError(errorMessage);
      }
    } catch (err) {
      setRegisterError('Lỗi máy chủ. Vui lòng thử lại sau.');
    }
  };

  return (
    <Box sx={{ py: 5 }}>
      <div className="container">
        <div className="row justify-content-center g-4">

          {/* Form Đăng Nhập */}
          <div className="col-md-5">
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Đăng nhập
              </Typography>
              <form onSubmit={handleLogin}>
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  required
                  margin="normal"
                  value={loginForm.email}
                  onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                />
                <TextField
                  label="Mật khẩu"
                  type="password"
                  fullWidth
                  required
                  margin="normal"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                />

                {loginError && (
                  <Typography color="error" sx={{ mt: 1 }}>
                    {loginError}
                  </Typography>
                )}

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Đăng nhập
                </Button>
              </form>
            </Paper>
          </div>

          {/* Form Đăng Ký */}
          <div className="col-md-5">
            <Paper elevation={3} sx={{ p: 4 }}>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Đăng ký
              </Typography>
              <form onSubmit={handleRegister}>
                <TextField
                  label="Họ và tên"
                  fullWidth
                  required
                  margin="normal"
                  value={registerForm.username}
                  onChange={(e) => setRegisterForm({ ...registerForm, username: e.target.value })}
                />
                <TextField
                  label="Email"
                  type="email"
                  fullWidth
                  required
                  margin="normal"
                  value={registerForm.email}
                  onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
                />
                <TextField
                  label="Mật khẩu"
                  type="password"
                  fullWidth
                  required
                  margin="normal"
                  value={registerForm.password}
                  onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
                />

                <TextField
                  label="Nhập lại mật khẩu"
                  type="password"
                  fullWidth
                  required
                  margin="normal"
                  value={registerForm.rePassword || ''}
                  onChange={(e) => setRegisterForm({ ...registerForm, rePassword: e.target.value })}
                />

                {registerError && (
                  <Typography color="error" sx={{ mt: 1 }}>
                    {registerError}
                  </Typography>
                )}

                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  fullWidth
                  sx={{ mt: 2 }}
                >
                  Đăng ký
                </Button>
              </form>
            </Paper>
          </div>
        </div>
      </div>
    </Box>
  );
}
